import { HeartPulse } from "lucide-react";
import { Link } from "react-router-dom";
import { scrollToId } from "@/App";

export const Footer = () => (
  <footer className="border-t border-[#E7E3D9] bg-[#F8F7F4] px-4 py-16 sm:px-6 lg:px-8" data-testid="footer">
    <div className="mx-auto max-w-7xl">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2 font-display text-2xl font-bold tracking-tight text-[#1E7B4F]">
            <HeartPulse className="h-7 w-7 text-[#F97316]" strokeWidth={2.2} />
            Desk to Defib
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#5F6E63]">
            Doctor-led, on-site CPR, defibrillator and choking training for workplaces across the UK.
            Give your workforce the confidence to save a life.
          </p>
        </div>
        <div>
          <p className="text-sm font-semibold uppercase tracking-wide text-[#14231B]">Explore</p>
          <div className="mt-5 space-y-3 text-sm">
            {[
              ["What we do", "what-we-do"],
              ["How it works", "how-it-works"],
              ["Pricing", "pricing"],
              ["About", "about"],
              ["FAQ", "faq"],
              ["Book a session", "book"],
            ].map(([label, id]) => (
              <button key={id} data-testid={`footer-${id}-link`} onClick={() => scrollToId(id)} className="block text-[#5F6E63] hover:text-[#1E7B4F] transition-colors duration-300">
                {label}
              </button>
            ))}
          </div>
        </div>
        <div>
          <p className="text-sm font-semibold uppercase tracking-wide text-[#14231B]">Contact</p>
          <div className="mt-5 space-y-3 text-sm text-[#5F6E63]">
            <a href="mailto:hello@desktodefib.co.uk" className="block hover:text-[#1E7B4F] transition-colors duration-300">hello@desktodefib.co.uk</a>
            <a href="tel:+442080641252" className="block hover:text-[#1E7B4F] transition-colors duration-300">+44 (0)20 8064 1252</a>
            <p>United Kingdom — we come to you</p>
          </div>
        </div>
      </div>
      <div className="mt-12 flex flex-wrap items-center justify-between gap-4 border-t border-[#E7E3D9] pt-8 text-xs text-[#5F6E63]">
        <p>© {new Date().getFullYear()} Desk to Defib. All rights reserved.</p>
        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-[#1E7B4F] transition-colors duration-300">Admin</Link>
      </div>
    </div>
  </footer>
);
